import React, {useCallback} from 'react';
import {connect} from 'react-redux';
import {GatewayGetSchema} from '../../../../../api/DBSchema/Gateway';
import {SMCCheckbox} from '../../../../../components/Simple/SMCCheckbox';
import {useTranslation} from 'react-i18next';
import SMCLabel from '../../../../../components/Simple/SMCLabel';
import EditorLayout from '../../../../../components/Layouts/EditorLayout';
import EmptyRow from '../../../../../components/Simple/EmptyRow';
import Indentation from '../../../../../components/Simple/Indentation';
import {SMCSelect, SMCOption} from '../../../../../components/Simple/SMCSelect';
import SMCNote from '../../../../../components/Simple/SMCNote';
import SMCLink from '../../../../../components/Simple/SMCLink';
import {push} from 'connected-react-router';
import {SMCPaths} from '../../../../../conf/Routes';
import { PortalSettingsGetSchema } from '../../../../../api/DBSchema/PortalSettings';

const pageSchema = GatewayGetSchema.pages.notifications;
const pageId = pageSchema.pageId;

function BaseNotifications({
    pageData,
    setObjectData,
    pageDisabled,
    navigateTo
}) {
    const { t } = useTranslation();
    
    const setPageValue = useCallback((param, newValue) => {
        setObjectData([pageId, param], newValue);
    }, [setObjectData]);


    // const notificationsMode       = pageData[pageSchema.notificationsMode];
    const notificationsLang       = pageData[pageSchema.notificationsLang];
    const infectedDevice          = pageData[pageSchema.infectedDevice];
    const fileBlocked             = pageData[pageSchema.fileBlocked];
    const fileDownloaded          = pageData[pageSchema.fileDownloaded];
    const emailReceived           = pageData[pageSchema.emailReceived];
    const emailBlocked            = pageData[pageSchema.emailBlocked];
    const deviceDetected          = pageData[pageSchema.deviceDetected];
    const deviceReconnected       = pageData[pageSchema.deviceReconnected];
    const primaryInternetRestored = pageData[pageSchema.primaryInternetRestored];
    const primaryInternetDown     = pageData[pageSchema.primaryInternetDown];
    const gatewayUp               = pageData[pageSchema.gatewayUp];
    const unexpectedReboot        = pageData[pageSchema.unexpectedReboot];
    const newFirmware             = pageData[pageSchema.newFirmware];
    const licenseAboutToExpire    = pageData[pageSchema.licenseAboutToExpire];
    const licenseActivated        = pageData[pageSchema.licenseActivated];
    const licenseExpired          = pageData[pageSchema.licenseExpired];
    const hwEMMC                  = pageData[pageSchema.hwEMMC]
/*     const vpnTunnelDown           = pageData[pageSchema.vpnTunnelDown]
    const vpnCertificateAboutToExpire   = pageData[pageSchema.vpnCertificateAboutToExpire]
    const vpnCertificateExpired   = pageData[pageSchema.vpnCertificateExpired] */
    
    const notificationsLangValues = pageSchema.notificationsLangValues;

    return (
        <EditorLayout>
            <SMCNote>
                {t('SMP.PLAN.SERVICES.NOTIFICATIONS.LINE1')}&nbsp;
                <SMCLink inline openInNewTab href="https://supportcenter.checkpoint.com/supportcenter/portal?eventSubmit_doGoviewsolutiondetails=&solutionid=sk148834">sk148834</SMCLink>&nbsp;
                {t('SMP.PLAN.SERVICES.NOTIFICATIONS.LINE2')}
            </SMCNote>
            {/* Language */}
            <SMCSelect
                label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.LANG')}
                value={notificationsLang}
                onChange={e => setPageValue(pageSchema.notificationsLang, e.target.value)}
                disabled={pageDisabled}
            >
                <SMCOption value={notificationsLangValues.english}>{t('SMP.PLAN.SERVICES.NOTIFICATIONS.LANG.ENGLISH')}</SMCOption>
            </SMCSelect>
            {/* Security incedents */}
            <SMCLabel bold>{t('SMP.PLAN.SERVICES.NOTIFICATIONS.SECURITY_INCIDENTS')}</SMCLabel>
            <Indentation>
                {/* Infected device detected */}
                <SMCCheckbox
                    disabled={pageDisabled}
                    checked={infectedDevice}
                    onChange={e => setPageValue(pageSchema.infectedDevice, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.INFECTED_DEVICE_DETECTED')}
                />
                {/* Malicious file blocked */}
                <SMCCheckbox
                    disabled={pageDisabled}
                    checked={fileBlocked}
                    onChange={e => setPageValue(pageSchema.fileBlocked, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.MALICIOUS_FILE_BLOCKED')}
                />
                {/* Malicious file downloaded */}
                <SMCCheckbox
                    disabled={pageDisabled}
                    checked={fileDownloaded}
                    onChange={e => setPageValue(pageSchema.fileDownloaded, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.MALICIOUS_FILE_DOWNLOADED')}
                />
                {/* Malicious e-mail received */}
                <SMCCheckbox
                    disabled={pageDisabled}
                    checked={emailReceived}
                    onChange={e => setPageValue(pageSchema.emailReceived, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.MALICIOUS_EMAIL_RECEIVED')}
                />
                {/* Malicious e-mail blocked */}
                <SMCCheckbox
                    disabled={pageDisabled}
                    checked={emailBlocked}
                    onChange={e => setPageValue(pageSchema.emailBlocked, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.MALICIOUS_EMAIL_BLOCKED')}
                />
            </Indentation>

            {/* Networking Events */}
            <SMCLabel bold>{t('SMP.PLAN.SERVICES.NOTIFICATIONS.NET_EVENTS')}</SMCLabel>
            <Indentation>
                {/* New device detected */}
                <SMCCheckbox
                    disabled={pageDisabled}
                    checked={deviceDetected}
                    onChange={e => setPageValue(pageSchema.deviceDetected, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.NEW_DEVICE_DETECTED')}
                />
                {/* Device reconnected */}
                <SMCCheckbox
                    disabled={pageDisabled}
                    checked={deviceReconnected}
                    onChange={e => setPageValue(pageSchema.deviceReconnected, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.DEVICE_RECONNECTED')}
                />
                {/* Primary Internet restored */}
                <SMCCheckbox
                    disabled={pageDisabled}
                    checked={primaryInternetRestored}
                    onChange={e => setPageValue(pageSchema.primaryInternetRestored, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.PRIMARY_INTERNET_RESTORED')}
                />
                {/* Primary Internet is down */}
                <SMCCheckbox
                    disabled={pageDisabled}
                    checked={primaryInternetDown}
                    onChange={e => setPageValue(pageSchema.primaryInternetDown, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.PRIMARY_INTERNET_DOWN')}
                />
                {/* Security gateway is up */}
                <SMCCheckbox
                    disabled={pageDisabled}
                    checked={gatewayUp}
                    onChange={e => setPageValue(pageSchema.gatewayUp, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.SEC_GW_UP')}
                />
                {/* Unexpected reboot */}
                <SMCCheckbox
                    disabled={pageDisabled}
                    checked={unexpectedReboot}
                    onChange={e => setPageValue(pageSchema.unexpectedReboot, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.UNEXPECTED_REBOOT')}
                />
            </Indentation>

            {/* Operational Events */}
            <SMCLabel bold>{t('SMP.PLAN.SERVICES.NOTIFICATIONS.OP_EVENTS')}</SMCLabel>
            <Indentation>
                {/* New firmware available */}
                <SMCCheckbox
                    disabled={pageDisabled}
                    checked={newFirmware}
                    onChange={e => setPageValue(pageSchema.newFirmware, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.NEW_FIRM_AVAIL')}
                />
                {/* License about to expire */}
                <SMCCheckbox
                    disabled={pageDisabled}
                    checked={licenseAboutToExpire}
                    onChange={e => setPageValue(pageSchema.licenseAboutToExpire, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.LIC_ABOUT_TO_EX')}
                />
                {/* License activated */}
                <SMCCheckbox
                    disabled={pageDisabled}
                    checked={licenseActivated}
                    onChange={e => setPageValue(pageSchema.licenseActivated, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.LIC_ACTIVATED')}
                />
                {/* License expired */}
                <SMCCheckbox
                    disabled={pageDisabled}
                    checked={licenseExpired}
                    onChange={e => setPageValue(pageSchema.licenseExpired, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.LIC_EX')}
                />
            </Indentation>

             {/* Hardware Events */}
             <SMCLabel bold>{t('SMP.PLAN.SERVICES.NOTIFICATIONS.HW_EVENTS')}</SMCLabel>
            <Indentation>
                {/* EMMC about to be full */}
                <SMCCheckbox
                    tooltip={t("com.sofaware.db.EMMC_FLASH_WARNING")}
                    disabled={pageDisabled}
                    checked={hwEMMC}
                    onChange={e => setPageValue(pageSchema.hwEMMC, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.HW_EMMC')}
                /> 
            </Indentation>

             {/* VPN Events */}
{/*              <SMCLabel bold>{t('SMP.PLAN.SERVICES.NOTIFICATIONS.VPN_EVENTS')}</SMCLabel>
            <Indentation> */}
                {/* VPN tunnel is down */}
{/*                 <SMCCheckbox
                    tooltip={t("com.sofaware.db.VPN_TUNNEL_WARNING")}
                    disabled={pageDisabled}
                    checked={vpnTunnelDown}
                    onChange={e => setPageValue(pageSchema.vpnTunnelDown, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.VPN_TUNNEL_DOWN')}
                />  */}
                {/* VPN certificate is about to expire */}
{/*                 <SMCCheckbox
                    tooltip={t("com.sofaware.db.VPN_TUNNEL_WARNING")}
                    disabled={pageDisabled}
                    checked={vpnCertificateAboutToExpire}
                    onChange={e => setPageValue(pageSchema.vpnCertificateAboutToExpire, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.VPN_CERT_ABOUT_TO_EX')}
                />  */}
                {/* VPN certificate expired */}
{/*                 <SMCCheckbox
                    tooltip={t("com.sofaware.db.VPN_TUNNEL_WARNING")}
                    disabled={pageDisabled}
                    checked={vpnCertificateExpired}
                    onChange={e => setPageValue(pageSchema.vpnCertificateExpired, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.NOTIFICATIONS.VPN_CERT_EXPIRED')}
                /> 
            </Indentation> */}

            <EmptyRow />

            <SMCLabel>
                {t('SMP.PLAN.SERVICES.NOTIFICATIONS.LINE3')}&nbsp;
                <SMCLink inline disabled={pageDisabled} onClick={() => navigateTo(SMCPaths.portalSettings+'?page='+PortalSettingsGetSchema.pages.notificationGateways.pageId)}>{t('SMP.PLAN.SERVICES.NOTIFICATIONS.CONF')}</SMCLink>&nbsp;
                {t('SMP.PLAN.SERVICES.NOTIFICATIONS.LINE4')}
            </SMCLabel>
        </EditorLayout>
    );
}

const mapStateToProps = null;

const mapDispatchToProps = {
    navigateTo: push
}

export default connect(mapStateToProps, mapDispatchToProps)(BaseNotifications);